<template>
    <div class="year-character-page">
        <!-- 0、顶部标题栏部分 -->
        <year-title-bar></year-title-bar>

        <div class="year-top-content" v-bind:class="{'year-top-content2': characterUnlockTime != 0}">
            <!-- 1、预测说明内容部分 -->
            <div class="year-character-info-content" :style="characterDesData && characterDesData.bg ? 'background-image: url('+characterDesData.bg+'); background-size: 100% 100%;' : ''">
                <div class="year-cic-content scroll-touch2">
                    <div class="year-cic-text" v-for="tData in characterDesData.info">
                        <p class="year-cic-text-title" v-if="tData.t"><span>{{ tData.t }}</span></p>
                        <p v-for="pText in tData.c" v-html="pText"></p>
                    </div>
                </div>
            </div>
            <!-- 2、八字验证内容部分 -->
            <div class="year-content-box">
                <div class="year-content-light"></div>
                <div class="year-content-light2"></div>
                <div class="year-content-light3"></div>
                <div class="year-content-box-border">
                    <div class="year-content-content">
                        <div class="year-content-animal" :class="'year-'+curYear"></div>
                        <div class="year-content-title year-content-title1"><span>八字验证</span></div>
                        <div class="year-content-content-c" v-bind:class="{'no-bg': characterUnlockTime != 0}">
                            <p class="year-content-content-p">在计算年运之前请先验证生辰八字的准确性，我们以性格特征为必须验证项，<span class="red">如果多数相符，说明生日信息无误，可以继续后面的测评</span>，否则建议确认好生日信息再继续，注意生日信息以实际出生地的时间为准，不要以身份证为准，且只支持北半球出生生日。</p>
                            <!-- 未解锁状态:免费解锁 -->
                            <div class="year-content-btn-box" v-if="characterUnlockTime == 0">
                                <report-button
                                    v-bind:buttonType="'2'"
                                    v-bind:freeBtn="true"
                                    v-bind:clickFunc="clickUnLock">
                                </report-button>
                            </div>
                            <!-- 已解锁状态:展示性格数据内容 -->
                            <div class="report-result-ct-content year-character-content-content" v-else>
                                <!-- describe -->
                                <p :class="{'report-result-ct-p-pad': describeData.indexOf('外在性格：') != -1 || describeData.indexOf('内在性格：') != -1}" v-for="describeData in characterAIData.describe" v-bind:key="describeData + Math.random(0, 10)" v-html="UTILS.getReportCharacter(describeData)"></p>
                                <!-- suggest -->
                                <p class="nature-c-paragraph p-ral p-blank"><span class="report-green-title">针对性建议：</span></p>
                                <p v-for="suggestData in characterAIData.suggest" v-bind:key="suggestData + Math.random(0, 10)"  class="">{{suggestData}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 3、开始计算按钮 -->
        <div class="year-bottom-btn-box" v-if="characterUnlockTime != 0">
            <button class="year-bottom-button" @click="clickStart">开始计算生成年运报告</button>
        </div>
        <!-- 4、提示解锁成功的弹框 -->
        <van-popup class="report-result-suc" v-bind:value="showPaySuc" @click-overlay="clickPayPop">
            <div class="report-result-suc-content">
                <img v-bind:src="sucGif" alt="">
            </div>
        </van-popup>

    </div>
</template>

<script>
import YearTitleBar from '../../layouts/year/YearTitleBar.vue'
import ReportButton from '../../layouts/report/ReportButton.vue'
import { MIX, UTILS, UA } from '../../modules/utils';
import { CONFIG } from '../../modules/config';
export default {
    name: 'YearCharacterPage',
    components: { YearTitleBar, ReportButton },
    computed: {
        characterDesData() {
            return this.$store.state.year.characterDesData;
        },
        characterAIData() {
            return this.$store.state.year.characterAIData;
        },
        characterUnlockTime() {
            return this.$store.state.year.characterUnlockTime;
        },
        showDownloadPop() {
            return this.$store.state.pay.showDownloadPop;
        },
        showVipBtn() {
            return this.$store.state.report.showVipBtn;
        },
        curYear() {
            return this.$store.state.year.curYear;
        },
    },
    data() {
        return {
            UTILS: UTILS,
            showPaySuc: false,
            sucGif: require('../../assets/images/report/report-suc.gif'),
        }
    },
    mounted() {
        setTimeout(() => {
            window.scrollTo(0, 0);
            this.initData();
            this.initDom();
        }, 20);
    },
    methods: {
        initData() {
            var detailInfo = this.$store.state.detail.personInfo;
            console.log('initData-----', detailInfo)
            if(!detailInfo.id) {
                this.$router.replace('/record');
                return;
            }
        },
        initDom() {
            var curParams = this.$router.history.current.params;
            var fromPage = this.$store.state.report.fromPage;
            console.log('Report---initDom------', curParams, fromPage)
        },
        clickUnLock() {
            this.$store.dispatch('year/unlockYearCharacter', {
                cb: ()=> {
                    // 显示并定时隐藏支付成功提示
                    this.showPaySuc = true;
                    setTimeout(() => {
                        this.showPaySuc = false;
                    }, 3000);
                }
            })
        },
        clickPayPop() {
            this.showPaySuc = false;
        },
        clickStart() {
            let curParams = this.$router.history.current.params;
            this.$router.replace('/generate/year');
            setTimeout(() => {
                this.$bus.emit('setCurParams', curParams);
            }, 20);
        }
    }
}
</script>